import React from 'react';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import { SPACE, FONT_SIZES, COLOR } from 'config';
import { rem } from 'polished';
import styled from 'styled-components';
import { Flex } from 'grid-styled';
import Heading from 'components/Heading';
import media from 'utils/media';
import Button from 'components/Button';

const DividerHeading = styled(Heading)`
  line-height:2rem;
  text-align:center;

  ${media.md.css`
    line-height:2.5rem;
  `}

  b{
    font-weight:normal;
    color:${COLOR.base};
  }
  margin-bottom: 2rem;
`;

const BottomWrapper = styled(Flex)`
  flex-direction:column;
  align-items:center;
  margin-bottom:${rem(SPACE[9])};
  
  .font-blue:{
    color:${COLOR.base};
  }
`;

const BottomHeading = styled(DividerHeading)`
  line-height:2.5rem;
  text-align:center;
  b{
    font-weight:normal;
    color:${COLOR.base};
  }
`;

const StyledBottomButton = styled(Button)`
  color:${COLOR.white};
  background-color:${COLOR.base};
  border-radius:5px;
  padding:16px;
  margin-top: -12px;
  font-weight: bold;
  ${media.md.css`
  line-height: 1 !important;
  `};
  line-height: 1.5 !important;
  &:hover{
    background-color:${COLOR.base};
  }
`;

const LearnMore = () =>
  (<BottomWrapper px={rem(SPACE[3])} >
    <BottomHeading
      as="h2"
      heavy
      fontSize={[rem(FONT_SIZES[6]), rem(FONT_SIZES[7]), rem(FONT_SIZES[7])]}
      width={['80%', '90%', '90%']}
    >
      <FormattedHTMLMessage id="landing.mobileWallets.learnMore.text" />
    </BottomHeading>
    <StyledBottomButton href="https://skycoin.com/ecosystem/" big>
      <FormattedMessage id="landing.mobileWallets.learnMore.button" />
    </StyledBottomButton>
  </BottomWrapper>);

export default LearnMore;



// WEBPACK FOOTER //
// ./src/components/MobileWalletsLanding/components/LearnMore.js